import styled from 'styled-components';
import { BodyTextRegularB } from '@/shared/ui/typography2';
import { useScopedI18n } from '@locales/client';
import { useEffect, useState } from 'react';
import { Image } from '@/shared/ui/image';
import { Line, TitleContainer } from '@/shared/ui/footer/styles';
import { useBrandTheme } from '@/shared/hooks';

export const FooterContacts = () => {
  const t = useScopedI18n('common.footer');
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const { isMillion } = useBrandTheme();

  useEffect(() => {
    const handleResize = () => {
      const innerWidth = window.innerWidth;
      setMenuIsOpen(menuIsOpen || innerWidth > 640);
    };
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const options = [
    { value: 'support@pingwin.games', label: t('support_contacts_tech') },
    { value: 'security@pingwin.games', label: t('support_contacts_security') },
    { value: 'business@pingwin.games', label: t('support_contacts_business') },
    { value: 'partners@pingwin.games', label: t('support_contacts_partners') },
  ];

  function clickHandler(value: string) {
    window.location.href = `mailto:${value}`;
  }

  return (
    <BlockWrapper>
      <TitleContainer>
        <BodyTextRegularB color="#AFAFAF">
          {t('support_contacts').toUpperCase()}
        </BodyTextRegularB>
        <Line $hideOnMobile />
      </TitleContainer>
      <ContactList>
        {options
          .filter((option, index) =>
            isMillion ? index === 0 : index === 0 || menuIsOpen
          )
          .map((option, index) => (
            <ContactItem key={index} $menuIsOpen={menuIsOpen}>
              <BodyTextRegularB color="#AFAFAF">
                {option.label}
              </BodyTextRegularB>
              <BodyTextRegularB
                color="#FFF"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  clickHandler(option.value);
                }}
              >
                {option.value}
              </BodyTextRegularB>
              {index === 0 && !menuIsOpen && (
                <ExpandButton onClick={() => setMenuIsOpen(!menuIsOpen)}>
                  <Image
                    src="/images/icons/indicator-lang.svg"
                    width={16}
                    height={16}
                    style={{
                      transition: 'all .2s ease',
                      transform: menuIsOpen ? 'rotate(0deg)' : 'rotate(180deg)',
                    }}
                    alt="indicator"
                  />
                </ExpandButton>
              )}
            </ContactItem>
          ))}
      </ContactList>
    </BlockWrapper>
  );
};

const BlockWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;

const ContactList = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 640px) {
    border-radius: 8px;
    background: #27262b;
  }
  @media screen and (min-width: 640px) {
    gap: 12px;
  }
`;

const ContactItem = styled.div<{ $menuIsOpen?: boolean }>`
  position: relative;
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr;
  gap: 4px;

  @media screen and (min-width: 641px) {
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 640px) {
    padding: 8px 12px;

    &:not(:last-child)::after {
      content: '';

      position: absolute;
      left: 8px;
      bottom: 0;
      width: calc(100% - 16px);
      height: 1px;
      background-color: #3f3f3f;
    }
  }

  ${(props) =>
    props.$menuIsOpen &&
    `
          @media screen and (min-width: 481px) and (max-width: 640px) {
            grid-template-rows: 1fr;
            grid-template-columns: 1fr 1fr;
          }`}
`;

const ExpandButton = styled.button`
  position: absolute;
  width: 16px;
  height: 16px;
  right: 12px;
  top: 18px;
  z-index: 2;
`;
